(function () {
  const VISIBLE_ROWS = 3;
  const SELECTOR_LIST = '.lb-list';
  const SELECTOR_CARD = '.lb-product-card, .lb-flat-card, lb-flat-card, lb-upsell-flat-card';

  // 读取 gift-box 内容，转换成 lb-list 能用的卡片
  function buildGiftCards() {
    const giftBox = document.querySelector('.custom-gift-box ul');
    if (!giftBox) return [];

    const items = Array.from(giftBox.querySelectorAll('li'));

    return items.map(li => {
      const img = li.querySelector('img')?.src || '';
      const title = li.querySelector('p')?.innerText || '';
      const price = li.querySelector('.custom-price div')?.innerText || '';

      const wrapper = document.createElement('lb-upsell-flat-card');
      wrapper.className = "lb-flat-card lb-flat-cta-button-price";
      wrapper.style.cssText = `
        border-color: rgb(228, 231, 236);
        border-width: 0px;
        border-radius: 8px;
        gap: 8px;
        background-color: #fff;
        padding: 8px;
        margin: 4px 0px;
      `;

      wrapper.innerHTML = `
        <lb-card-image lb-preview="true" class="lb-image-host hydrated">
          <div class="lb-card-image-cont">
            <img class="lb-card-img lb-image-pd" alt="${title}" src="${img}" style="border-radius: 4px;">
          </div>
        </lb-card-image>

        <div class="lb-cta-cont">

          <lb-card-title lb-preview="true" class="hydrated">
            <div class="lb-card-title-cont">
              <div class="lb-card-title lb-title-ld" tabindex="0" role="link"
                style="font-size: 14px; font-weight: 400;">
                ${title}
              </div>
            </div>
          </lb-card-title>

          <lb-price class="hydrated">
            <div class="lb-price lb-price-sl-button">
              <div class="lb-price">
                <span class="lb-price-sale-price money"
                  style="font-size: 14px; font-weight: 600;">${price}</span>
              </div>
            </div>
          </lb-price>

          <div class="lb-cta-actions">
            <div class="lb-cta-action-pickers">
              <lb-variant-picker lb-action="" class="hydrated"></lb-variant-picker>
            </div>
            <lb-button lb-action-product="" lb-action="" class="lb-button-host lb-button-sm hydrated">
              <div class="lb-button-cont lb-button-sm">
                <div role="button" tabindex="0" class="lb-button"
                  style="color: #fff; background-color: rgb(var(--color-sale-price)); border-radius: 6px; border-width: 0px;
                        font-size: 14px; font-weight: 400; height: 28px; border-style: solid;">
                  Free
                </div>
              </div>
            </lb-button>
          </div>

        </div>
      `;

      return wrapper;
    });
  }


  function initList(listEl) {
    if (!listEl || listEl.dataset.smoreInit) return;
    listEl.dataset.smoreInit = 'true';

    // ★★★注入 gift items
    const giftCards = buildGiftCards();
    giftCards.forEach(card => listEl.prepend(card));

    // ★★★插入后，记录 gift 数量，用来修正行数
    const GIFT_COUNT = giftCards.length;

    const cards = Array.from(listEl.querySelectorAll(SELECTOR_CARD + ', .gift-card'));
    if (!cards.length) return;

    const imgs = Array.from(listEl.querySelectorAll('img'));
    const imgsLoaded = imgs.map(img => img.complete ? Promise.resolve() : new Promise(r => img.onload = r));

    Promise.all(imgsLoaded).then(() => {

      const rowMap = new Map();
      const listTop = listEl.getBoundingClientRect().top;

      cards.forEach(card => {
        const top = Math.round(card.getBoundingClientRect().top - listTop);
        if (!rowMap.has(top)) rowMap.set(top, []);
        rowMap.get(top).push(card);
      });

      const rows = Array.from(rowMap.values());
      if (rows.length <= VISIBLE_ROWS) return;

      const hiddenRows = rows.slice(VISIBLE_ROWS);
      console.log(hiddenRows , VISIBLE_ROWS ,GIFT_COUNT, 'hiddenRows')
      hiddenRows.forEach(row => row.forEach(card => card.style.display = 'none'));

      let p = listEl.querySelector('.lb-showmore-wrapper');
      const extraCount = Math.max(hiddenRows.flat().length - 1 - GIFT_COUNT , 0);

      if (!p) {
        p = document.createElement('p');
        p.className = 'tw-text-right tw-text-vi md:tw-py-4 tw-py-2 lb-showmore-wrapper';
        p.style.marginTop = '8px';
        p.innerHTML = `
          <span id="fbt-show-btn" class="tw-cursor-pointer lb-showmore-btn-wrapper" style="user-select:none;">
            <span more="">Show more (${extraCount}) ....</span>
            <span less="" style="display:none">Show less</span>
          </span>
        `;
        listEl.appendChild(p);
      }

      const btn = p.querySelector('#fbt-show-btn');
      let expanded = false;

      btn.addEventListener('click', () => {
        if (!expanded) {
          hiddenRows.forEach(row => row.forEach(card => card.style.display = ''));
          btn.querySelector('[more]').style.display = 'none';
          btn.querySelector('[less]').style.display = '';
          expanded = true;
        } else {
          hiddenRows.forEach(row => row.forEach(card => card.style.display = 'none'));
          btn.querySelector('[more]').style.display = '';
          btn.querySelector('[less]').style.display = 'none';
          expanded = false;
        }
      });
    });
  }

  function initAll() {
    document.querySelectorAll(SELECTOR_LIST).forEach(initList);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  const bodyObserver = new MutationObserver(mutations => {
    mutations.forEach(m => {
      if (!m.addedNodes) return;
      m.addedNodes.forEach(node => {
        if (!(node instanceof HTMLElement)) return;
        if (node.matches && node.matches(SELECTOR_LIST)) initList(node);
        else if (node.querySelectorAll) node.querySelectorAll(SELECTOR_LIST).forEach(initList);
      });
    });
  });
  bodyObserver.observe(document.body, { childList: true, subtree: true });
})();
